define(["exports", "@babel/runtime/helpers/esm/assertThisInitialized", "@babel/runtime/helpers/esm/inheritsLoose", "@babel/runtime/helpers/esm/defineProperty", "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose", "react", "styled-components", "../../atoms/", "react-intl-universal", "../../utils", "../../themes"], function (_exports, _assertThisInitialized2, _inheritsLoose2, _defineProperty2, _taggedTemplateLiteralLoose2, _react, _styledComponents, _atoms, _reactIntlUniversal, _utils, _themes) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

  var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Footer = void 0;
  _assertThisInitialized2 = _interopRequireDefault(_assertThisInitialized2);
  _inheritsLoose2 = _interopRequireDefault(_inheritsLoose2);
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _taggedTemplateLiteralLoose2 = _interopRequireDefault(_taggedTemplateLiteralLoose2);
  _react = _interopRequireWildcard(_react);
  _styledComponents = _interopRequireWildcard(_styledComponents);
  _reactIntlUniversal = _interopRequireDefault(_reactIntlUniversal);

  var _templateObject;

  var LanguageButton = _styledComponents.default.button.withConfig({
    displayName: "Footer__LanguageButton",
    componentId: "sc-irgv38-0"
  })(["", ""], _themes.resetButton);

  var FooterStyled = _styledComponents.default.footer.withConfig({
    displayName: "Footer__FooterStyled",
    componentId: "sc-irgv38-1"
  })(["align-items:center;border-top:1px solid ", ";display:flex;flex-direction:column;justify-content:space-between;margin-bottom:32px;margin-top:32px;padding:16px 0 0 0;position:relative;z-index:3;@media print{display:none;}> span{height:24px;width:87px;}div{align-items:center;flex-direction:column;display:flex;> span{margin-right:16px;}p{align-items:center;color:", ";display:inline-flex;flex-direction:column;font-size:1.3em;text-align:center;a{color:", ";font-weight:", ";margin-top:8px;}}}", ""], function (_ref) {
    var theme = _ref.theme;
    return theme.colors.gray;
  }, function (_ref2) {
    var theme = _ref2.theme;
    return theme.colors.darkGray;
  }, function (_ref3) {
    var theme = _ref3.theme;
    return theme.colors.newOrange;
  }, function (_ref4) {
    var theme = _ref4.theme;
    return theme.font.semibold;
  }, _themes.device.desktop(_templateObject || (_templateObject = (0, _taggedTemplateLiteralLoose2.default)(["\n    flex-direction: row;\n\n    div {\n      flex-direction: row;\n\n      p {\n        flex-direction: row;\n        text-align: left;\n\n        span::after {\n          content: '|';\n          margin: 0 4px;\n        }\n\n        a {\n          margin-top: 0;\n        }\n      }\n    }\n  "]))));

  var SelectLang = _styledComponents.default.div.withConfig({
    displayName: "Footer__SelectLang",
    componentId: "sc-irgv38-2"
  })(["position:relative;button,a{", ";align-items:center;color:", ";display:flex;font-size:1.4em;outline:none;padding:8px;width:100%;text-decoration:none;", " &:hover{color:", ";box-icon{fill:", ";}}box-icon{fill:", ";&[name='chevron-up']{transition:transform 0.2s ", ";}&[name='globe']{margin-right:8px;}", ";}span{margin-right:8px;}}ul{", ";background-color:", ";border-radius:4px;bottom:calc(100% + 16px);box-shadow:0 1px 2px 0 rgba(0,0,0,0.3);opacity:0;padding:8px;pointer-events:none;position:absolute;right:-4px;transform:translate3d(0,10px,0);transition:visibility 0.8s linear,opacity 0.6s ", ",transform 0.2s ", ";visibility:hidden;width:149px;&::before{border:9px solid transparent;border-top-color:", ";bottom:-18px;content:'';position:absolute;right:50%;transform:translate3d(50%,0,0);}", ";}"], _themes.resetButton, function (_ref5) {
    var theme = _ref5.theme;
    return theme.colors.darkGray;
  }, function (_ref6) {
    var noFlags = _ref6.noFlags;
    return noFlags ? (0, _styledComponents.css)(["justify-content:center;"]) : (0, _styledComponents.css)(["justify-content:flex-start;"]);
  }, function (_ref7) {
    var theme = _ref7.theme;
    return theme.colors.orange;
  }, function (_ref8) {
    var theme = _ref8.theme;
    return theme.colors.orange;
  }, function (_ref9) {
    var theme = _ref9.theme;
    return theme.colors.darkGray;
  }, function (_ref10) {
    var theme = _ref10.theme;
    return theme.easing.ease;
  }, function (_ref11) {
    var open = _ref11.open;
    return open && (0, _styledComponents.css)(["transform:rotate(180deg);"]);
  }, _themes.resetList, function (_ref12) {
    var theme = _ref12.theme;
    return theme.colors.white;
  }, function (_ref13) {
    var theme = _ref13.theme;
    return theme.easing.ease;
  }, function (_ref14) {
    var theme = _ref14.theme;
    return theme.easing.ease;
  }, function (_ref15) {
    var theme = _ref15.theme;
    return theme.colors.white;
  }, function (_ref16) {
    var open = _ref16.open;
    return open && (0, _styledComponents.css)(["pointer-events:auto;transform:translate3d(0,0,0);visibility:visible;opacity:1;"]);
  });

  var LangsArray = [{
    lang: '_ptBR',
    countryCode: 'BR',
    i18n: 'pt-BR'
  }, {
    lang: '_enUS',
    countryCode: 'US',
    i18n: 'en-US'
  }, {
    lang: '_esALT',
    countryCode: 'ES',
    i18n: 'es-ES'
  }];

  var Footer = /*#__PURE__*/function (_Component) {
    (0, _inheritsLoose2.default)(Footer, _Component);

    function Footer() {
      var _this;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _Component.call.apply(_Component, [this].concat(args)) || this;
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
        open: false
      });
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "toggleMenu", function () {
        _this.setState(function (prevState) {
          return {
            open: !prevState.open
          };
        });
      });
      return _this;
    }

    var _proto = Footer.prototype;

    _proto.componentDidMount = function componentDidMount() {
      var _this2 = this;

      var _this$props = this.props,
          i18n = _this$props.i18n,
          currentLanguage = _this$props.currentLanguage;
      (0, _utils.initIntl)(i18n, currentLanguage).then(function () {
        return _this2.setState({
          i18nLoaded: true
        });
      });
    };

    _proto.render = function render() {
      var _this$props2 = this.props,
          globalUrl = _this$props2.globalUrl,
          currentYear = _this$props2.currentYear,
          currentLanguage = _this$props2.currentLanguage,
          handleLanguage = _this$props2.handleLanguage,
          noFlags = _this$props2.noFlags;
      var _this$state = this.state,
          open = _this$state.open,
          i18nLoaded = _this$state.i18nLoaded;
      var current = LangsArray.filter(function (item) {
        return item.i18n === currentLanguage;
      })[0];
      var Langs = LangsArray.filter(function (item) {
        return item.i18n !== currentLanguage;
      });
      return !i18nLoaded ? null : /*#__PURE__*/_react.default.createElement(_atoms.Container, null, /*#__PURE__*/_react.default.createElement(FooterStyled, null, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_atoms.Logo, {
        kind: "footer"
      }), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("span", null, "\xA9 ", currentYear, " ", _reactIntlUniversal.default.get('FOOTER.COPYRIGHT')), ' ', /*#__PURE__*/_react.default.createElement(_atoms.GlobalLink, {
        globalUrl: globalUrl,
        to: "/termos-de-uso",
        title: _reactIntlUniversal.default.get('FOOTER.TERMOS')
      }, _reactIntlUniversal.default.get('FOOTER.TERMOS')))), /*#__PURE__*/_react.default.createElement(SelectLang, {
        open: open,
        noFlags: noFlags
      }, /*#__PURE__*/_react.default.createElement("button", {
        onClick: this.toggleMenu
      }, noFlags ? /*#__PURE__*/_react.default.createElement("box-icon", {
        name: "globe"
      }) : /*#__PURE__*/_react.default.createElement(_atoms.Flag, {
        countryCode: current.countryCode
      }), _reactIntlUniversal.default.get("FOOTER.IDIOMA." + current.lang), /*#__PURE__*/_react.default.createElement("box-icon", {
        name: "chevron-up",
        open: open
      })), /*#__PURE__*/_react.default.createElement("ul", null, Langs.map(function (item) {
        return /*#__PURE__*/_react.default.createElement("li", {
          key: item.countryCode
        }, /*#__PURE__*/_react.default.createElement(LanguageButton, {
          href: "",
          onClick: function onClick() {
            handleLanguage(item.lang);
            window.location.reload();
          }
        }, !noFlags && /*#__PURE__*/_react.default.createElement(_atoms.Flag, {
          countryCode: item.countryCode
        }), _reactIntlUniversal.default.get("FOOTER.IDIOMA." + item.lang)));
      })))));
    };

    return Footer;
  }(_react.Component);

  _exports.Footer = Footer;
  Footer.defaultProps = {
    handleLanguage: function handleLanguage() {},
    currentLanguage: 'pt-BR'
  };
});